import { styled } from '@mui/material/styles';
import { Box } from 'shared/mui/Box';

export const FormItemStyled = styled(Box)({
  width: '100%',
  marginTop: '24px',
});
